//src/services/contactMessages.api.js
import { apiRequest } from "./api";

export const sendMessage = (data) =>
  apiRequest("/contact-messages", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const getMyMessages = () =>
  apiRequest("/contact-messages/mine");
